// extracted by mini-css-extract-plugin
export var buttonContent = "_3i-0";
export var centered = "_3i-1";
export var centeredFlex = "_3i-2";
export var errorText = "_3i-3";
export var icon = "_3i-4";
export var iconButtonContent = "_3i-5";
export var monospace = "_3i-6";
export var padded = "_3i-7";